import { ClearRounded } from '@mui/icons-material';
import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { usePlaceImgUrlsForCard } from '../../hooks/trip/trip.hooks';
import { TripCard } from '../../redux/trip/trip.types';
import CardDetailsModal from '../CardDetailsModal/CardDetailsModal';
import './SingleCard.scss';

export interface CardProps {
  card: TripCard;
  tripId: string;
  canEdit?: boolean;
  handleClose?: () => void;
  handleDeleteClick?: (event: React.MouseEvent<EventTarget>) => void;
}

function SingleCard({ card, tripId, canEdit = false, handleClose, handleDeleteClick }: CardProps) {
  const [modalOpen, setModalOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  const { imgUrls, onImgError } = usePlaceImgUrlsForCard(tripId, card, true, { coverOnly: true });

  const handleModalOpen = () => setModalOpen(true);
  const handleModalClose = () => {
    setModalOpen(false);
    searchParams.delete('card');
    searchParams.delete('card-tab');
    setSearchParams(searchParams);
  };

  return (
    <>
      <div
        className='single-card-container'
        onClick={handleModalOpen}
      >
        <div className='single-card-img-container'>
          {imgUrls.length > 0 ? (
            <img
              className='single-card-img cover'
              src={imgUrls[0]}
              onError={onImgError}
            />
          ) : (
            <img
              className='single-card-img contain'
              src={'/svgs/logo.png'}
            />
          )}
        </div>
        <div className='single-card-description-container'>
          <h3 className='single-card-name'>{card.customName ?? card.name}</h3>
          <ClearRounded
            className='exit'
            onClick={handleClose}
          />
        </div>
      </div>

      {modalOpen && (
        <CardDetailsModal
          card={card}
          tripId={tripId}
          canEdit={canEdit}
          open={modalOpen}
          handleClose={handleModalClose}
          handleDeleteClick={handleDeleteClick}
        />
      )}
    </>
  );
}

SingleCard.displayName = 'SingleCard';
export default SingleCard;
